import { Loader, Logo, useAPI } from "@/components/lib";
import CoachCard from "./coachCard";

export default function Coaches() {
  const { data, loading } = useAPI("/api/coach");

  const coaches = data?.filter((coach: any) => !coach.hidden) || [];

  return (
    <main className="text-white min-h-screen">
      <div className="flex flex-col justify-center items-center pb-4 lg:hidden">
        <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />
      </div>
      {loading ? (
        <div className="flex justify-center items-center py-10">
          <Loader />
        </div>
      ) : coaches?.length > 0 ? (
        <div className="mt-2 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {coaches.map((coach: any) => (
            <CoachCard coach={coach} key={coach.id} />
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center py-10 lg:text-2xl">
          <h2>No coaches found</h2>
        </div>
      )}
    </main>
  );
}
